import axiosAutoCheck from "global/helpers/axiosAutoCheckIn";
import {
  GET_ATENCION_SIN_TURNO,
  GET_ATENCION_SIN_TURNO_FAIL,
  GET_ATENCION_SIN_TURNO_SUCCESS,
  GET_CENTROS,
  GET_CENTROS_FAIL,
  GET_CENTROS_SUCCESS,
} from "../ActionTypes";
import axiosLogin from "global/helpers/axiosLogin";

export const wsGetAtencionSinTurno = (nextStep, idCentro) => (dispatch) => {
  dispatch({ type: GET_ATENCION_SIN_TURNO });
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/his/demanda/${idCentro ? idCentro : ""}`)
      .then((resp) => {
        dispatch({
          type: GET_ATENCION_SIN_TURNO_SUCCESS,
          payload: resp.data,
        });
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        dispatch({ type: GET_ATENCION_SIN_TURNO_FAIL, payload: err?.data });
        if (nextStep) nextStep(false, err?.response?.data);
      });
  });
};

export const wsGetAtencionSinTurnoQr = (idCentro, nextStep) => (dispatch) => {
  dispatch({ type: GET_ATENCION_SIN_TURNO });
  axiosAutoCheck().then((respuesta) => {
    respuesta
      .get(`/demanda/${idCentro}`)
      .then((resp) => {
        dispatch({
          type: GET_ATENCION_SIN_TURNO_SUCCESS,
          payload: resp.data,
        });
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        dispatch({ type: GET_ATENCION_SIN_TURNO_FAIL, payload: err?.data });
        if (nextStep) nextStep(false, err?.response?.data);
      });
  });
};

export const wsGetAllDemandaQr =
  (idCentro, idOrden, nextStep) => (dispatch) => {
    dispatch({ type: GET_ATENCION_SIN_TURNO });
    axiosLogin().then((respuesta) => {
      respuesta
        .get(`/his/demanda/all/${idCentro}/${idOrden}`)
        .then((resp) => {
          dispatch({
            type: GET_ATENCION_SIN_TURNO_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({ type: GET_ATENCION_SIN_TURNO_FAIL, payload: err?.data });
          if (nextStep) nextStep(false, err?.response?.data);
        });
    });
  };

export const wsGetAllCentrosDemandaQr = (nextStep) => (dispatch) => {
  dispatch({ type: GET_ATENCION_SIN_TURNO });
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`his/demanda/allCentros`)
      .then((resp) => {
        dispatch({
          type: GET_ATENCION_SIN_TURNO_SUCCESS,
          payload: resp.data,
        });
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        dispatch({ type: GET_ATENCION_SIN_TURNO_FAIL, payload: err?.data });
        if (nextStep) nextStep(false, err?.response?.data);
      });
  });
};

export const wsGetVerificarOsAtencionSinTurnoQr =
  (medico, especialidad, nextStep) => (dispatch) => {
    axiosLogin().then((respuesta) => {
      respuesta
        .get(`/his/demanda/verificarOsQr/${medico}/${especialidad}/${false}`)
        .then((resp) => {
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          if (nextStep) nextStep(false, err?.response?.data);
        });
    });
  };

export const wsPostTomarAtencionSinTurnoQr = (dto, nextStep) => () => {
  axiosLogin().then((respuesta) => {
    respuesta
      .post(`/his/demanda/Qr`, dto)
      .then((resp) => {
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        if (nextStep) nextStep(false, err);
      });
  });
};

export const wsPostTomarAtSinTurnoQr = (dto, nextStep) => () => {
  axiosLogin().then((respuesta) => {
    respuesta
      .post(`/his/demanda/sin_turno`, dto)
      .then((resp) => {
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        if (nextStep) nextStep(false, err);
      });
  });
};

// export const wsPostTomarAtSinTurnoQr = (dto, nextStep) => () => {
//   axiosAutoCheck().then((respuesta) => {
//     respuesta
//       .post(`/demanda/AtSinTurnoQr`, dto)
//       .then((resp) => {
//         if (nextStep) nextStep(true, resp.data);
//       })
//       .catch((err) => {
//         if (nextStep) nextStep(false, err);
//       });
//   });
// };

export const wsGetCentros = (nextStep) => (dispatch) => {
  dispatch({ type: GET_CENTROS });
  axiosAutoCheck().then((respuesta) => {
    respuesta
      .get(`/Texto/GetCentros`)
      .then((resp) => {
        dispatch({ type: GET_CENTROS_SUCCESS, payload: resp.data });
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        dispatch({ type: GET_CENTROS_FAIL, payload: err });
        if (nextStep) nextStep(false, err?.response?.data);
      });
  });
};

export const setCentroId = (id) => (dispatch) => {
  dispatch({ type: GET_CENTROS_SUCCESS, payload: id });
};
